import React, { useEffect, useState } from "react";
import { NAV } from "@/constants/testIds";
import { motion } from "framer-motion";

const links = [
  { id: "about", label: "About", test: NAV.linkAbout },
  { id: "services", label: "Services", test: NAV.linkServices },
  { id: "work", label: "Work", test: NAV.linkWork },
  { id: "contact", label: "Contact", test: NAV.linkContact },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-white/75 border-b border-zinc-200/60"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between h-16">
        <a
          href="#top"
          data-testid={NAV.logo}
          className="font-display text-xl tracking-tighter text-zinc-900"
        >
          AKSHAY<span className="klein-text">.</span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.id}
              data-testid={l.test}
              href={`#${l.id}`}
              className="text-sm font-medium text-zinc-700 hover:text-zinc-900 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid={NAV.ctaTalk}
          className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold bg-zinc-900 text-white hover:-translate-y-0.5 transition-transform"
        >
          Let&rsquo;s Talk
          <span aria-hidden>→</span>
        </a>

        <button
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className="md:hidden flex flex-col gap-1.5 p-2"
        >
          <span className={`h-0.5 w-6 bg-zinc-900 transition-transform ${open ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`h-0.5 w-6 bg-zinc-900 transition-opacity ${open ? "opacity-0" : ""}`} />
          <span className={`h-0.5 w-6 bg-zinc-900 transition-transform ${open ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-zinc-200 bg-white">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-zinc-800"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center px-5 py-3 text-sm font-semibold bg-zinc-900 text-white"
            >
              Let&rsquo;s Talk →
            </a>
          </div>
        </div>
      )}
    </motion.header>
  );
};
